import { apiClient } from './client'
import type { CursorPage } from './accounts'
import type { TimelineEntry } from '../types/timeline'

/**
 * `GET /api/v1/events` (docs/api-spec.md line 167, docs/adr-log.md ADR-0046) — the universal
 * per-entity Timeline read every primary-entity page's `TimelinePanel` calls.
 */
export interface ListEventsParams {
  targetType: string
  targetId: string
  eventType?: string | null
  cursor?: string | null
  limit?: number
}

export async function listEvents(params: ListEventsParams, signal?: AbortSignal): Promise<CursorPage<TimelineEntry>> {
  const q = new URLSearchParams()
  q.set('target', `${params.targetType},${params.targetId}`)
  if (params.eventType) q.set('event_type', params.eventType)
  if (params.cursor) q.set('cursor', params.cursor)
  q.set('limit', String(params.limit ?? 50))
  const { data } = await apiClient.get<CursorPage<TimelineEntry>>(`/events?${q.toString()}`, { signal })
  return data
}
